import { RawAxiosRequestHeaders } from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

export const addAuthorizationHeader = async (headers: RawAxiosRequestHeaders) => {
  return fetchAuthSession()
    .then(session => {
      const token = session?.tokens?.idToken;
      return { ...headers, Authorization: `Bearer ${token}` };
    })
    .catch(_error => headers);
};
